exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number-input {\n  /* border-radius: 4px; */\n  background-color: unset;\n  border: none;\n  border-bottom: 1px solid #409eff;\n}\n.q-field__marginal {\n  height: auto !important;\n}\n", ""]);

// exports
